import React, { useState, useEffect } from 'react';
import Markdown from 'global/components/Markdown';
import NavToTop from 'feature/nav/NavToTop';
import { GridContainer } from 'global/components/perform-grid';
import { ChangelogContent } from './Changelog.styles';
import PageTitle from 'global/components/PageTitle';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

import changelog from 'global/../../CHANGELOG.md';

export default function Changelog(props) {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    props.changeTitle?.(<PageTitle Icon={NewReleasesIcon} title="What's New" />);
  }, []);

  useEffect(() => {
    fetch(changelog)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, []);

  return (
    <GridContainer>
      <ChangelogContent>
        <NavToTop />
        <Markdown>{markdown}</Markdown>
      </ChangelogContent>
    </GridContainer>
  );
}
